<template>
  <div id="app">
      <router-view/>
  </div>
</template>
<script>
import {weixinShare} from './utils/wxShare'
export default {
  name: 'App',
  methods: {
    loadWx() {
      const path = this.$route.path;
      let descr = '福建华闽联信基金管理有限公司是经福建省政府批准，由福建华闽实业集团联合市场化专业团队于2017年共同发起设立的私募股权投资基金管理机构。公司源于2016年省政府第76次常务会议关于设立福建省旅游产业发展基金的战略部署，汇聚了来自全国专业资管机构的精英团队，在基金管理领域具备丰富经验。';
      let image = 'https://gf60.org.cn/upload/owe/e89d860319ce44ba868d837c2d5a25f4.png';

      let title = document.title;

      weixinShare({
        link: window.location.href,
        image,
        title,
        descr
      });
    }
  },
    watch: {
    '$route.path': {
      immediate: true,
      handler(v) {
        this.loadWx();
      }
    }
  },
  
}
</script>
<style lang="less">
body {
  margin: 0;
  color: #2e2e2e;
  font-family: 'Arial';

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

}
</style>
